import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('cta-banner', '.cta-banner', (ctaBanner) => {
  const close = ctaBanner.querySelector('.cta-banner-close');
  const hero = ctaBanner.closest('.heroUnified, .heroUtil');

  if (!hero || !close) return;

  let observer = null;
  let prevHeight = 0;

  checkDismissal();
  addEvents(close, 'click', handleClose);

  
  // --------------- //
  // -- Functions -- //
  // --------------- //

  function checkDismissal() {
    let dismissed = window.sessionStorage.getItem('cta-banner-dismissed') || false;

    if (!dismissed) {
      initObserver();
      hero.classList.add('banner-will-open');

      setTimeout(() => {
        hero.classList.add('banner-is-open');
      }, 1000)
    }
    else {
      handleClose();
    }
  }

  function initObserver() {
    observer = new ResizeObserver(entries => {
      const entry = entries[0];
      const { height } = entry.contentRect;
      handleHeightChange(height);
    });

    observer.observe(ctaBanner);
  }

  function handleHeightChange(height) {
    if (height !== prevHeight) {
      prevHeight = height;
      hero.style.setProperty('--bannerHeight', height + 'px');
    }
  }

  function handleClose(e) {
    if (e) {
      hero.classList.remove('banner-is-open')
      window.sessionStorage.setItem("cta-banner-dismissed", true)
      if (observer) {
        observer.unobserve(ctaBanner);
        observer.disconnect();
      }
    }

    setTimeout(() => {
      ctaBanner.remove();
      hero.style.removeProperty('--bannerHeight');
    }, 500);
  }
})